export const blockIconsActivitiesRealEstateAgentNew = (
	<span className='material-symbols-outlined'>real_estate_agent</span>
);
